import { Paper } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Tooltip from "@material-ui/core/Tooltip";
import CircularProgress from "@material-ui/core/CircularProgress";
import { instance } from "Actions/AxiosInstance";
import get from "lodash/get";
import downloadIcon from "Assets/newicons/action/download/outline/download-outline-16px.svg";
import uploadIcon from "Assets/newicons/action/upload/outline/upload-outline-16px.svg";
import accountingIcon from "Assets/newicons/finance/accounting/outline/accounting-outline-16px.svg";
import salaryIcon from "Assets/newicons/finance/salary/outline/salary-outline-16px.svg";
import taxIcon from "Assets/newicons/finance/tax/outline/tax-outline-16px.svg";
import salaryAdjustmentImg from "Assets/Svg/salary-adjustment.svg";
import PageHeader from "Component/Headers/pageHeader";
import ThumbnailBig from "Component/Thumbnail/ThumbnailRectangleBase64";
import leaveIcon from "Assets/newicons/app/leaves/outline/leaves-outline-16px.svg";
import { ErrorMessages } from "Constants";
import React, { Component } from "react";
import Dropzone from "react-dropzone";
import { connect } from "react-redux";
import Configs from "Constants/Configs";
import gratuityIcon from "Assets/newicons/finance/provident-fund/outline/provident-fund-outline-16px.svg";

export class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      time: 0,
      loading: false,
    };
  }

  saveProgress = () => {
    const { payrollcycle, salarycycle, postdataforemplist } = this.props;
    const { issaveinprogress } = this.props.SaveInProgressReducer;
    console.log("issaveinprogress: ", issaveinprogress);
    if (!issaveinprogress) {
      this.props.setSaveProgress(true);
      const postdata = {
        payrollcycledurationid: get(payrollcycle, "payrollcycledurationid", ""),
        salarycycleid: get(salarycycle, "salarycycleid", ""),
        salarycyclesplitid: get(salarycycle, "displayvalue", ""),
        isdraft: true,
        stepnumber: 3,
        generateddataid: null,
        processdata: postdataforemplist && postdataforemplist.payrollgroup,
      };
      instance
        .post("payroll/createpayrolldraft", postdata)
        .then(() => {
          this.props.removeSaveProgress();
          this.props.enqueueSnackbar(ErrorMessages.E0000, {
            variant: "success",
          });
          this.props.setCurrentView("home");
        })
        .catch((error) => {
          this.props.removeSaveProgress();
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    }
  };

  onGeneratePayroll = () => {
    const {
      salarycycle,
      payrollcycle,
      isSpeicalCase,
      specialEmps,
      normalEmps,
      postdataforemplist,
    } = this.props;
    const postdata = {
      payrollcycledurationid: get(payrollcycle, "payrollcycledurationid", 12),
      salarycycleid: get(salarycycle, "salarycycleid", 12),
      salarycyclesplitid: get(salarycycle, "displayvalue", 12),
      employeeids: isSpeicalCase
        ? specialEmps
            .filter((x) => !x.ispayslipgenerated)
            .map((x) => x.employeeid)
        : normalEmps
            .filter((x) => !x.ispayslipgenerated)
            .map((x) => x.employeeid),
      grouptypeids: postdataforemplist.payrollgroup.map((g) => g.grouptypeid).join(",") ? postdataforemplist.payrollgroup.map((g) => g.grouptypeid).join(",") : null,
    };
    if (postdata.employeeids && postdata.employeeids.length > 0) {
      this.props.enqueueSnackbar(
        `You are about to generate payroll data of ${postdata.employeeids.length} employees?`,
        {
          variant: "warning",
          action: [
            <Button
              key="key"
              color="inherit"
              size="small"
              onClick={() => {
                const { issaveinprogress } = this.props.SaveInProgressReducer;
                console.log("issaveinprogress: ", issaveinprogress);
                if (!issaveinprogress) {
                  this.props.setSaveProgress(true);
                  this.props.closeSnackbar();
                  const totalseconds = postdata.employeeids.length * 5;
                  const secondsforintervals = (totalseconds) * 1000;
                  console.log("secondsforintervals: ", secondsforintervals);
                  this.interval = setInterval(
                    () =>
                      this.setState({
                        time: this.state.time >= 99 ? 99 : this.state.time + 1,
                      }),
                    secondsforintervals / 100,
                  );
                  console.log("this.interval: ", this.interval);
                  this.setState(
                    {
                      loading: true,
                    },
                    () => {
                      console.log("here", this.state.time, this.state.loading);
                      instance
                        .post("payroll/calculatesalary", postdata)
                        .then(() => {
                          this.props.removeSaveProgress();

                          setTimeout(function () {
                            this.setState(
                              {
                                time: 100,
                                loading: false,
                              },
                              () => {
                                clearInterval(this.interval);
                                this.props.enqueueSnackbar("Your payroll data is processing... please check after 10 mins.", {
                                  variant: "success",
                                });
                                console.log("salary slip generated");
                                this.props.setCurrentView("payrolloverview");
                              },
                            );
                          }.bind(this), secondsforintervals);
                        })
                        .catch((error) => {
                          this.props.removeSaveProgress();
                          this.setState(
                            {
                              time: 0,
                              loading: false,
                            },
                            () => {
                              clearInterval(this.interval);
                              // this.props.setCurrentView("payrolloverview");
                              this.props.enqueueSnackbar(
                                error.response
                                  ? error.response.data.error.message
                                  : error.message,
                                { variant: "error" },
                              );
                            },
                          );
                        });
                    },
                  );
                }
              }}
            >
              Yes
            </Button>,
            <Button
              key="key"
              color="inherit"
              size="small"
              onClick={() => this.props.closeSnackbar()}
            >
              No
            </Button>,
          ],
        },
      );
    } else {
      this.props.enqueueSnackbar("No record found", {
        variant: "error",
      });
    }
  };

  render() {
    const {
      fillDataMode,
      setsalaryadjustpage,
      postData,
      isSpeicalCase,
    } = this.props;
    console.log("redner time: ", this.state.time);
    return (
      <div>
        <Grid container className="margin-top-16" spacing={3}>
          <Grid item xs={12} md={7} sm={12} className="position-rel">
            <div style={{ position: "absolute", top: -44 }}>
              <PageHeader
                header={
                  fillDataMode
                    ? "Step 3a: File arrears and LOP"
                    : "Step 3: Salary adjustments"
                }
              />

              <div>
                <div>
                  <p className="normal-dark">
                    Great, now we need to file in any salary adjustments.
                  </p>
                </div>
              </div>

              {fillDataMode ? (
                <div>
                  <ol className="padding-left-16">
                    <li className="small-blue margin-bottom-16 t-bold">
                      Download CSV template <img src={downloadIcon}></img>
                    </li>
                    <li className="small-dark-secondary margin-bottom-16">
                      File arrears and LOP details to the CSV file
                    </li>
                    <li className="small-dark-secondary">
                      Upload the populated CSV file
                      <div className="width50 margin-top-16">
                        {postData && !postData.header ? (
                          <Tooltip title="Upload image" placement="top">
                            <Dropzone
                              onDrop={(e) => this.uploadDoc("header", e)}
                              multiple={false}
                              accept="image/*"
                              maxSize={2000000}
                              className="drag-drop"
                            >
                              <div className="uploader-wrapper cursor-pointer">
                                <div
                                  className="vertical-center"
                                  style={{ height: 20 }}
                                >
                                  <img
                                    src={uploadIcon}
                                    className="vertical-middle"
                                  ></img>
                                  <span className="margin-left-16 small-blue">
                                    Upload image
                                  </span>
                                </div>
                              </div>
                            </Dropzone>
                          </Tooltip>
                        ) : (
                          <ThumbnailBig
                            key="key"
                            onDelete={() => this.onDeleteDoc("header")}
                            onEdit={(file) => this.uploadDoc("header", file)}
                            filetypes="image/*"
                            doc={{
                              url:
                                postData && postData.header
                                  ? postData.header
                                  : "",
                            }}
                          />
                        )}
                      </div>
                    </li>
                  </ol>
                </div>
              ) : (
                <div>
                  <Paper
                    className="rounded-rectangle-paper margin-top-32 cursour-pointer"
                    style={{ padding: "16px 24px" }}
                    onClick={() => setsalaryadjustpage("LOP")}
                  >
                    <img
                      src={salaryIcon}
                      className="floatleft margin-right-16"
                    ></img>
                    <p className="small-dark-secondary">File arrears and LOP</p>
                  </Paper>
                  <Paper
                    className="rounded-rectangle-paper margin-top-8 cursour-pointer"
                    style={{ padding: "16px 24px" }}
                    onClick={() => setsalaryadjustpage("extrapayments")}
                  >
                    <img
                      src={accountingIcon}
                      className="floatleft margin-right-16"
                    ></img>
                    <p className="small-dark-secondary">File extra payments</p>
                  </Paper>
                  <Paper
                    className="rounded-rectangle-paper margin-top-8 cursour-pointer"
                    style={{ padding: "16px 24px" }}
                    onClick={() => setsalaryadjustpage("extradeduction")}
                  >
                    <img
                      src={taxIcon}
                      className="floatleft margin-right-16"
                    ></img>
                    <p className="small-dark-secondary">
                      File extra deductions
                    </p>
                    {/* <Collapse
                      in={isexpanded}
                      timeout="auto"
                      unmountOnExit
                      className="padding-top-4"
                    >
                      <Grid container spacing={3} className="margin-top-8">
                        <Grid
                          item
                          xs={12}
                          md={6}
                          sm={12}
                          className="position-rel"
                        >
                          <div className="salary-adjustment-action">
                            <img src={downloadBigIcon}></img>
                            <p className="small-dark-secondary margin-top-8">
                              Fill in csv file
                            </p>
                          </div>
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          md={6}
                          sm={12}
                          className="position-rel"
                        >
                          <div className="salary-adjustment-action">
                            <img src={softwareIcon}></img>
                            <p className="small-dark-secondary margin-top-8">
                              Fill online (Coming soon)
                            </p>
                          </div>
                        </Grid>
                      </Grid>
                    </Collapse> */}
                  </Paper>
                  <Paper
                    className="rounded-rectangle-paper margin-top-8 cursour-pointer"
                    style={{ padding: "16px 24px" }}
                    onClick={() => setsalaryadjustpage("manualtax")}
                  >
                    <img
                      src={accountingIcon}
                      className="floatleft margin-right-16"
                    ></img>
                    <p className="small-dark-secondary">Manual tax</p>
                  </Paper>
                  {Configs.MODE == "DEV"
                  && <Paper
                    className="rounded-rectangle-paper margin-top-8 cursour-pointer"
                    style={{ padding: "16px 24px" }}
                    onClick={() => setsalaryadjustpage("leaveencashment")}
                  >
                    <img
                      src={leaveIcon}
                      className="floatleft margin-right-16"
                    ></img>
                    <p className="small-dark-secondary">
                      Leave encashment adjustment
                    </p>
                  </Paper>}
                  {Configs.MODE == "DEV"
                  && <Paper
                    className="rounded-rectangle-paper margin-top-8 cursour-pointer"
                    style={{ padding: "16px 24px" }}
                    onClick={() => setsalaryadjustpage("gratuitypayments")}
                  >
                    <img
                      src={gratuityIcon}
                      className="floatleft margin-right-16"
                    ></img>
                    <p className="small-dark-secondary">Gratuity payments</p>
                  </Paper>}
                </div>
              )}
            </div>
          </Grid>
          <Grid
            item
            xs={12}
            md={5}
            sm={12}
            className="display-flex"
            style={{ flexDirection: "column", alignItems: "center" }}
          >
            <div>
              <img src={salaryAdjustmentImg}></img>
            </div>
          </Grid>
        </Grid>

        <div className="width100">
          <div>
            <div className="floatleft" style={{ marginLeft: 172 }}>
              <div
                className="width100"
                style={{
                  position: "fixed",
                  left: 0,
                  background: "white",
                  bottom: 0,
                  padding: 10,
                  borderTop: "1px solid #d4d4d4",
                  zIndex: 0,
                }}
              >
                <div>
                  {/* <div className="floatleft" style={{ marginLeft: 172 }}>
                    {!isSpeicalCase
                    && <Button
                      className="btn btn-secondary-md-blue margin-right-16"
                      variant="contained"
                      disabled={this.props.SaveInProgressReducer.issaveinprogress}
                      onClick={this.saveProgress}
                    >
                      Save progress
                    </Button>}
                  </div> */}
                  <div className="floatright" style={{ marginRight: 72 }}>
                    <div>
                      <Button
                        className="btn btn-secondary-md-blue margin-right-16"
                        variant="contained"
                        onClick={() => this.props.setCurrentView("analyse")}
                      >
                        Go back
                      </Button>

                      {/* <Button
                        className="btn btn-primary-md-blue"
                        variant="contained"
                        onClick={() =>
                          this.props.setCurrentView("payrolloverview")
                        }
                      >
                        Skip
                      </Button> */}
                      <Button
                        className="btn btn-primary-md-blue"
                        variant="contained"
                        onClick={this.onGeneratePayroll}
                      >
                        Generate payroll data
                      </Button>
                    </div>
                  </div>
                  <div className="clearfloat"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Dialog
          fullWidth={true}
          maxWidth="sm"
          open={this.state.loading}
          // onClose={() => this.setState({ openDialog: false, empform1: null })}
          aria-labelledby="max-width-dialog-title"
          classes={{
            scrollPaper: "no-shadow bg-transparent",
            paper: "no-shadow bg-transparent",
          }}
        >
          <DialogContent>
            <div
              className="progess-wrapper"
              style={{
                position: "relative",
                width: 120,
                height: 120,
                margin: "0 auto",
                color: "#fff",
              }}
            >
              <CircularProgress
                className="goal-progress"
                variant="static"
                size={100}
                value={parseInt(this.state.time)}
                color="inherit"
              />
              <div
                className="progress-line"
                style={{ borderColor: "#fff" }}
              ></div>
              <div
                className="vertical-center text-center"
                style={{ height: 30 }}
              >
                <span
                  style={{
                    display: "block",
                    fontSize: 24,
                    color: "#fff",
                    fontWeight: "bold",
                  }}
                >
                  {this.state.time}%
                </span>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Home);
